import React from 'react'
import SignIN from '../components/common/signIn'
import Footer from '../components/common/footer'
import Navbar from '../components/common/navbar'
import AdvertiseProduct from '../components/home/advertiseProduct'

const SignINPage = () => {
  return (
    <div>
        <Navbar />
        <AdvertiseProduct/>
        <SignIN/>
        <Footer/>
    </div>
  )
}

export default SignINPage